import React from "react";
import styles from "./styles/Home.module.css";
import logo_cloud from "../imgs/logo_cloud.png";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      json: null,
    };
  }

  componentDidMount() {
    fetch("assets/cloud.json")
      .then((res) => res.json())
      .then((json) => this.setState({json}));
  }

  render() {
    const {json} = this.state;
    return (
      <div className={styles.bg}>
        <div className={styles.logo}>
          <img src={logo_cloud} className={styles.img} />
          <div className={styles.logoText}>大豪云先行版APP下载安装</div>
        </div>
        <ul className={styles.linkBtns}>
          <a href={`assets/${json && json.name}.apk`}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgAndroid} />
              <span className={styles.linkDownload}>安卓先行版</span>
            </li>
          </a>
          <div className={styles.gap} />
          <a href={json && json.link_ios}>
            <li className={styles.linkBtn}>
              <span className={styles.btnImgIos} />
              <span className={styles.linkDownload}>IOS先行版</span>
            </li>
          </a>
        </ul>
        <div className={styles.net}>先行版抢先体验</div>
      </div>
    );
  }
}
